import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 36, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function PageHero({ overline, lines, intro, testId }) {
  return (
    <header className="px-6 pb-16 pt-36 sm:px-10 md:pt-44 lg:px-16" data-testid={testId}>
      <motion.p
        className="overline-label mb-6"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
      >
        {overline}
      </motion.p>
      <h1 className="font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink sm:text-6xl md:text-7xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.14} className={line.accent ? "italic text-terracotta" : ""}>
            {line.text}
          </MaskedLine>
        ))}
      </h1>
      {intro && (
        <motion.p
          className="mt-8 max-w-xl text-base leading-relaxed text-ink/70 md:text-lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
        >
          {intro}
        </motion.p>
      )}
    </header>
  );
}
